var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonCls,attrs:{"type":"button","disabled":!!this.disabled},on:{"click":_vm.trigger}},[(!!_vm.iconCode)?_c('i',{class:_vm.iconCls}):_vm._e(),_vm._v(" "),(_vm.hasText)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6fb7c7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","audio":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/ByButton2.vue
// module id = null
// module chunks = 